export default __webpack_public_path__ + "static/media/dynamo.d169e56c.png";